export enum ClassifierMappingUrl {
  CLASSIFIER_MAPPING = '/classifier-mappings{/id}{?page,size,sort*,search,code,name,' +
    'classifierFromCode,classifierToCode,description,validFrom,validTo,hasCategories}',
  CLASSIFIER_MAPPING_UPLOAD = '/classifier-mappings/upload-excel',
  SEARCH = '/classifier-mappings/search{?searchText,classifierIdFrom,classifierCodeFrom,selectedMapping,page,size}',
}
